import color from "../resource/color";

export const STATUS_COLOR_MAPPING: any = {
  ACTIVE: color["success"],
  INACTIVE: color["placeholder"],
  HOLD: color["warning"],
};
